// ¿Este número tiene WhatsApp? — hook para el badge en vivo de los forms (pago manual,
// perfil). Se dispara on-blur (no por tecla: el server rate-limita a 12/min). NO bloquea:
// tener un teléfono sin WhatsApp es legítimo; el badge solo avisa para evitar el caso
// "el perfil trae un número al que nadie puede escribir" (caso Mi Bendito Café, 18-jul-26).
import { useRef, useState } from 'react';
import { baseAuthApi } from '../api/baseAuthApi';

export type WaCheckState = 'idle' | 'checking' | 'yes' | 'no' | 'unknown';

export function useWaCheck() {
  const [state, setState] = useState<WaCheckState>('idle');
  const lastChecked = useRef<string>('');

  const reset = () => { setState('idle'); lastChecked.current = ''; };

  const check = async (raw: string) => {
    const digits = (raw || '').replace(/\D/g, '');
    if (digits.length < 10) { reset(); return; }
    if (digits === lastChecked.current) return;   // mismo número, no re-consultar
    lastChecked.current = digits;
    setState('checking');
    try {
      const r = await baseAuthApi.waCheck(digits);
      // Si el usuario siguió editando mientras respondía, descarta el resultado viejo.
      if (lastChecked.current === digits) setState(r.exists ? 'yes' : 'no');
    } catch {
      if (lastChecked.current === digits) setState('unknown');  // 429/503 → sin veredicto, no alarmar
    }
  };

  return { state, check, reset };
}

// Texto y clases del badge (compartido para que los dos forms se vean igual).
export function waBadge(state: WaCheckState): { text: string; className: string } | null {
  switch (state) {
    case 'checking': return { text: 'Verificando WhatsApp…', className: 'text-content-3' };
    case 'yes': return { text: '✓ Este número tiene WhatsApp', className: 'text-green-600 dark:text-green-400' };
    case 'no': return { text: '✗ Este número no tiene WhatsApp — revísalo por si hay un error', className: 'text-amber-600 dark:text-amber-400' };
    default: return null;
  }
}
